module.exports = __webpack_public_path__ + "img/huide.262b142a.jpeg";